import { Chip, styled } from '@mui/material';
import { PinnacleChipProps } from './PinnacleChip.types';

const StyledPinnacleChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'coverButton',
})<PinnacleChipProps>(({ theme, coverButton }) => ({
  borderColor: '#003367',
  backgroundColor: '#003367',
  color: 'white',
  fontWeight: coverButton ? 600 : 600,
  fontSize: coverButton ? '14px' : '11px',
  lineHeight: coverButton ? '18px' : undefined,
  height: coverButton ? '44px' : undefined,
  width: coverButton ? '143px' : undefined,
  cursor: 'pointer',
  borderRadius: coverButton ? '24px' : '16px',
  '&:hover': {
    backgroundColor: '#003367',
  },
}));

export default StyledPinnacleChip;